(() => {
  const BLOCK_ID = 'sp-section-store-cart-offer';
  const STYLE_ID = 'sp-section-store-cart-offer-style';
  const APP_SELECTOR = 'section-store--cart-block';
  const MAX_WAIT_ATTEMPTS = 240;

  const strings = {
    title: '🎁 3 SQUICHIES = -15 % SUR LE MOINS CHER',
    unlocked: '🎉 Offre débloquée !',
    one: 'Encore 2 Squichies pour débloquer -15 % sur le moins cher ✨',
    two: "Plus qu’1 Squichy pour débloquer -15 % 👀",
    empty: 'Ajoute 3 Squichies pour débloquer -15 % sur le moins cher ✨',
  };

  const shadowCss = `
    #${BLOCK_ID}{padding:12px 16px 14px;border-bottom:1px solid var(--cart-divider-color,rgba(18,18,18,.08));background:#fff7fb;color:var(--cart-text-color,#4a1030)}
    #${BLOCK_ID} *{box-sizing:border-box}
    .sp-app-cart-offer__title{font-size:12px;font-weight:800;letter-spacing:.035em;line-height:1.35;color:#c72376}
    .sp-app-cart-offer__progress{display:flex;align-items:center;gap:9px;margin:7px 0 5px}
    .sp-app-cart-offer__dots{display:flex;gap:5px;line-height:1}
    .sp-app-cart-offer__dot{width:9px;height:9px;border:1.5px solid #f083b5;border-radius:999px;background:#fff}
    .sp-app-cart-offer__dot.is-filled{background:#df197a;border-color:#df197a}
    .sp-app-cart-offer__count{font-size:12px;font-weight:750;color:#087f8c}
    .sp-app-cart-offer__message{font-size:12px;font-weight:650;line-height:1.35;color:#4a1030}
    .sp-app-cart-offer__suggestions{display:flex;gap:8px;margin-top:10px;overflow-x:auto;padding-bottom:1px;scrollbar-width:none}
    .sp-app-cart-offer__suggestions::-webkit-scrollbar{display:none}
    .sp-app-cart-offer__suggestion{display:grid;grid-template-columns:34px minmax(0,1fr) auto;align-items:center;flex:0 0 min(245px,82vw);gap:7px;padding:6px;border:1px solid #f4b5d0;border-radius:10px;background:#fff}
    .sp-app-cart-offer__image{display:block;width:34px;height:34px;object-fit:contain;border-radius:7px;background:#fff}
    .sp-app-cart-offer__product{display:-webkit-box;overflow:hidden;color:#4a1030;font-size:11px;font-weight:700;line-height:1.22;text-decoration:none;-webkit-box-orient:vertical;-webkit-line-clamp:2}
    .sp-app-cart-offer__price{display:block;margin-top:1px;color:#087f8c;font-size:11px;font-weight:750}
    .sp-app-cart-offer__add{min-height:30px;padding:5px 8px;border:0;border-radius:8px;color:#fff;background:#df197a;font:inherit;font-size:11px;font-weight:800;cursor:pointer;white-space:nowrap}
    .sp-app-cart-offer__add:disabled{opacity:.65;cursor:wait}
    .sp-app-cart-offer__all{display:inline-block;margin-top:9px;color:#c72376;font-size:11px;font-weight:750;text-decoration:underline;text-underline-offset:2px}
  `;

  const getConfig = () => window.SquichPopCartOfferConfig || { collectionUrl: '/collections/all', suggestions: [] };
  const isSquichy = (item) => /squish|squich/i.test(String(item?.product_type || ''));
  const eligibleCount = (cart) => (cart?.items || []).reduce((total, item) => total + (isSquichy(item) ? Number(item.quantity || 0) : 0), 0);

  function waitForApp(attempt = 0) {
    const app = document.querySelector(APP_SELECTOR);
    if (app?.shadowRoot && window.SectionStoreCart?.subscribe) {
      install(app);
      return;
    }
    if (attempt < MAX_WAIT_ATTEMPTS) window.setTimeout(() => waitForApp(attempt + 1), 50);
  }

  function addStyle(root) {
    if (root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = shadowCss;
    root.append(style);
  }

  function getBlock(root) {
    let block = root.getElementById(BLOCK_ID);
    if (!block) {
      block = document.createElement('section');
      block.id = BLOCK_ID;
      block.setAttribute('aria-live', 'polite');
    }
    const reward = root.querySelector('.cart-reward-bar');
    const lineItems = root.querySelector('.cart-line-items');
    const target = reward || lineItems;
    if (target && block.previousElementSibling !== target) target.after(block);
    return block;
  }

  function suggestionMarkup() {
    const suggestions = getConfig().suggestions || [];
    if (!suggestions.length) return '';
    return `<div class="sp-app-cart-offer__suggestions" aria-label="Suggestions SquichPop">${suggestions.map((product) => `
      <article class="sp-app-cart-offer__suggestion">
        <a href="${escapeAttribute(product.url)}" aria-label="Voir ${escapeAttribute(product.title)}"><img class="sp-app-cart-offer__image" src="${escapeAttribute(product.image)}" alt=""></a>
        <div><a class="sp-app-cart-offer__product" href="${escapeAttribute(product.url)}">${escapeHtml(product.title)}</a><span class="sp-app-cart-offer__price">${escapeHtml(product.price)}</span></div>
        <button class="sp-app-cart-offer__add" type="button" data-variant-id="${Number(product.id)}">+ Ajouter</button>
      </article>`).join('')}</div>`;
  }

  function render(root, cart) {
    const count = eligibleCount(cart);
    const block = getBlock(root);
    if (!cart?.item_count) {
      block.remove();
      return;
    }
    const completed = Math.min(count, 3);
    const dots = [1, 2, 3].map((position) => `<span class="sp-app-cart-offer__dot${position <= completed ? ' is-filled' : ''}" aria-hidden="true"></span>`).join('');
    const message = count >= 3 ? strings.unlocked : count === 2 ? strings.two : count === 1 ? strings.one : strings.empty;
    const detail = count >= 3 ? '-15 % sur ton Squichy le moins cher.' : '';
    const config = getConfig();

    block.innerHTML = `
      <div class="sp-app-cart-offer__title">${strings.title}</div>
      <div class="sp-app-cart-offer__progress"><div class="sp-app-cart-offer__dots" role="progressbar" aria-label="${completed} Squichies sur 3" aria-valuemin="0" aria-valuemax="3" aria-valuenow="${completed}">${dots}</div><span class="sp-app-cart-offer__count">${completed} / 3 Squichies</span></div>
      <div class="sp-app-cart-offer__message">${message}${detail ? `<br>${detail}` : ''}</div>
      ${count < 3 ? suggestionMarkup() : ''}
      <a class="sp-app-cart-offer__all" href="${escapeAttribute(config.collectionUrl || '/collections/all')}">→ Voir tous les Squichies</a>`;
    block.querySelectorAll('[data-variant-id]').forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = Number(button.dataset.variantId);
        if (!variantId || !window.SectionStoreCart?.addItem) return;
        button.disabled = true;
        button.textContent = 'Ajout…';
        try {
          await window.SectionStoreCart.addItem({ id: variantId, quantity: 1 });
          window.SectionStoreCart.open();
        } catch (error) {
          button.textContent = 'Réessayer';
          button.disabled = false;
        }
      });
    });
  }

  function install(app) {
    if (app.dataset.spOfferMounted === 'true') return;
    app.dataset.spOfferMounted = 'true';
    const root = app.shadowRoot;
    addStyle(root);
    const update = (cart) => render(root, cart || window.SectionStoreCart.getCart());
    window.SectionStoreCart.ready.then(update).catch(() => {});
    window.SectionStoreCart.subscribe(update);
    window.addEventListener('section-store:cart:updated', (event) => update(event.detail?.cart));
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  }
  function escapeAttribute(value) { return escapeHtml(value); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => waitForApp(), { once: true });
  else waitForApp();
})();
